import { render, staticRenderFns } from "./DialogGeneratePchSaleBook.vue?vue&type=template&id=0a8d65ba&lang=pug&"
import script from "./DialogGeneratePchSaleBook.vue?vue&type=script&lang=js&"
export * from "./DialogGeneratePchSaleBook.vue?vue&type=script&lang=js&"
import style0 from "./DialogGeneratePchSaleBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogGeneratePchSaleBook.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VDatePicker,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
